<template>
  <div name="delete-bool-button">
    <template v-if="disable">
      <div class="del-disable">
        <i class="fa fa-trash text-gray icon-delete-desc"></i>
      </div>
    </template>
    <template v-else>
      <div @click="toggleDelete(!deleteIconBool)" :class="[ deleteIconBool ? 'del-checked' : 'del-unchecked' ]" class="cursor-pointer">
        <i :class="'fa fa-' + [ deleteIconBool ? 'trash' : 'trash-o' ]" class="icon-delete-desc"></i>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'delete-bool-button',
  data () {
    return {
      deleteIconBool: this.value,
      deleteIconDesc: (this.value) ? 'Delete' : 'None'
    }
  },
  watch: {
    value (newVal) {
      this.toggleDelete(newVal)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleDelete (deleteIconBool) {
      this.deleteIconBool = deleteIconBool
      this.deleteIconDesc = (deleteIconBool) ? 'Delete' : 'None'
      this.$emit('input', deleteIconBool)
    }
  }
}
</script>

<style>
.icon-delete-desc{
  margin:0 5px 0 0;
}
.del-disable {
  line-height: 37px;
  height: 35px;
  width: 30px;
  padding-left: 4px;
  margin:0 auto;
  text-align: center;
  font-weight:700;
  font-size:20px;
}
.del-unchecked {
  transition: background 0.3s ease;
  background:#FFF;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 30px;
  padding-left: 4px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  text-align: center;
  color:#757575;
  font-weight:700;
  font-size:20px;
}
.del-checked {
  transition: background 0.3s ease;
  background:#E53935;
  text-align: center;
  border-radius: 2px;
  line-height: 37px;
  height: 35px;
  width: 30px;
  padding-left: 4px;
  margin:0 auto;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  color:#FFF;
  font-size:20px;
}
</style>


// WEBPACK FOOTER //
// deleteButton.vue?0a02750c